import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./routes/ProtectedRoute";
import JartinetLayout from "./pages/jartinet/JartinetLayout";
import RootLayout from "./pages/RootLayout";
import { ErrorBoundary } from "./components/dev/ErrorBoundary";
import { JartinetClosed } from "./components/JartinetClosed";
import HomePage from "./pages/home";
import BandasPage from "./pages/bandas";
import HermandadesPage from "./pages/hermandades";
import HermandadPublicaPage from "./pages/hermandades/detalle";
import BandaPublicaPage from "./pages/bandas/detalle";
import HallOfFamePage from "./pages/jartinet/hall-of-fame";
import CarnetPage from "./pages/jartinet/carnet";
import PeriodicoPage from "./pages/periodico";
import ModUpdatesPage from "./pages/mod-updates";
import AvisoLegalPage from "./pages/legal/aviso-legal";
import PoliticaCookiesPage from "./pages/legal/politica-de-cookies";
import LoginPage from "./pages/login";
import RegisterPage from "./pages/register";
import JartinetHomePage from "./pages/jartinet/home";
import JartinetSocialPage from "./pages/jartinet/social";
import JartinetHermandadesPage from "./pages/jartinet/hermandades";
import JartinetArzobispadoPage from "./pages/jartinet/arzobispado";
import PersonalizablesPage from "./pages/jartinet/personalizables";
import PersonalizablesPedidosPage from "./pages/jartinet/personalizables/pedidos";
import JartinetCalendarioPage from "./pages/jartinet/calendario";
import JartinetModCofradePage from "./pages/jartinet/mod-cofrade";
import AdminHomePage from "./pages/jartinet/admin/home";
import AdminCalendarioPage from "./pages/jartinet/admin/calendario";
import AdminContratosPage from "./pages/jartinet/admin/contratos";
import AdminNoticiasPage from "./pages/jartinet/admin/noticias";
import AdminPeriodicoPage from "./pages/jartinet/admin/periodico";
import AdminSocialPage from "./pages/jartinet/admin/social";
import GalleryPage from "./pages/gallery";
import ApplyPage from "./pages/apply";
import CityPage from "./pages/city";
import NoticiasPage from "./pages/noticias";
import PublicSocialPage from "./pages/social";
import AdminAvisosPage from "./pages/jartinet/admin/avisos";
import AdminModPage from "./pages/jartinet/admin/mod";
import AvisosPage from "./pages/jartinet/avisos";
import PoliticaPrivacidadPage from "./pages/legal/politica-de-privacidad";
import JartinetBandasPage from "./pages/jartinet/bandas";
import JartinetPeriodicoPage from "./pages/jartinet/periodico";
import JartinetBuzonPage from "@/pages/jartinet/buzon/index.tsx";
import JartinetOrganizacionesPage from "./pages/jartinet/organizaciones";
import JartinetBancoPage from "./pages/jartinet/banco";
import JartinetInversionesPage from "./pages/jartinet/banco/inversiones";
import JartinetProgramaSemanaSantaPage from "./pages/jartinet/programa-semana-santa";
import AdminProgramaSS26Page from "./pages/jartinet/admin/programa-ss26";
import AdminBancoPage from "./pages/jartinet/admin/banco";
import AdminDiscordPage from "./pages/jartinet/admin/discord";
import AdminMapaPage from "./pages/jartinet/admin/mapa";
import AdminArzobispadoPage from "./pages/jartinet/admin/arzobispado";
import AdminHermandadesPage from "./pages/jartinet/admin/hermandades";
import AdminBandasPage from "./pages/jartinet/admin/bandas";
import AdminUsuariosPage from "./pages/jartinet/admin/usuarios";
import AdminPersonalizablesPage from "./pages/jartinet/admin/personalizables";
import AdminOrganizacionesPage from "./pages/jartinet/admin/organizaciones";
import AdminJartiBetPage from "./pages/jartinet/admin/jartibet";
import PeriodicoRedaccionPage from "./pages/jartinet/periodico-redaccion";
import JartiBetPage from "./pages/jartinet/jartibet";
import JarticardsPage from "./pages/jartinet/jarticards";
import AdminJarticardsPage from "./pages/jartinet/admin/jarticards";
import AdminSeguridadModPage from "./pages/jartinet/admin/seguridad-mod";
import AdminSeguridadRobloxPage from "./pages/jartinet/admin/seguridad-roblox";
import AdminMapaServidorPage from "./pages/jartinet/admin/mapa-servidor";
import AdminIglesiasPage from "./pages/jartinet/admin/iglesias";
import AdminTiempoPage from "./pages/jartinet/admin/tiempo";
import AdminActividadPage from "./pages/jartinet/admin/actividad";
import AdminCecopPage from "./pages/jartinet/admin/cecop";
import ComprobarShadersPage from "./pages/jartinet/comprobar-shaders";
import ElJartiInglesPage from "./pages/jartinet/eljartiingles";
import JartiInglesPedidosPage from "./pages/jartinet/eljartiingles/pedidos";
import AdminJartiInglesPage from "./pages/jartinet/admin/jartiingles";
import AdminShadersPage from "./pages/jartinet/admin/shaders";
import RenderProgramaSSPage from "./pages/render/programa-ss";
import AdminGaleriaPage from "./pages/jartinet/admin/galeria";
import AdminEstampitasPage from "./pages/jartinet/admin/estampitas";
import JartiMarchasPage from "./pages/jartinet/jartimarchas";
import AdminJartiMarchasPage from "./pages/jartinet/admin/jartimarchas";
import PrivacidadModPage from "./pages/legal/privacidad-mod";


const NotFoundPage = () => <div style={{padding:24}}><h1>404 Not Found</h1></div>;

// La web pública está ABIERTA. La plataforma interna (Jartinet) permanece
// CERRADA en producción: /login, /register y TODO /jartinet/* muestran la
// página "JARTINET CERRADA". En `npm run dev` (localhost) import.meta.env.PROD
// es false, así que en local Jartinet se ve siempre normal para poder trabajar.
// Para reabrir Jartinet: negar/quitar este guard y volver a desplegar hosting.
// Jartinet REABIERTA en producción. Para volver a cerrarla: poner `import.meta.env.PROD`.
const JARTINET_CLOSED = false;

export default function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route element={<RootLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/bandas" element={<BandasPage />} />
          <Route path="/hermandades" element={<HermandadesPage />} />
          <Route path="/hermandades/:id" element={<HermandadPublicaPage />} />
          <Route path="/bandas/:id" element={<BandaPublicaPage />} />
          <Route path="/periodico" element={<PeriodicoPage />} />
          <Route path="/mod-updates" element={<ModUpdatesPage />} />
          <Route path="/legal/aviso-legal" element={<AvisoLegalPage />} />
          <Route path="/legal/politica-de-privacidad" element={<PoliticaPrivacidadPage />} />
          <Route path="/legal/politica-de-cookies" element={<PoliticaCookiesPage />} />
          <Route path="/legal/privacidad-mod" element={<PrivacidadModPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/apply" element={<ApplyPage />} />
          <Route path="/city" element={<CityPage />} />
          <Route path="/noticias" element={<NoticiasPage />} />
          <Route path="/social" element={<PublicSocialPage />} />
        </Route>

        {/* Render del libro para el librito del mod: fuera de RootLayout (sin
            cabecera ni pie) porque lo fotografía Chrome headless, no un humano.
            Ver la Cloud Function `renderProgramaSS`. */}
        <Route path="/render/programa-ss" element={<RenderProgramaSSPage />} />

        {JARTINET_CLOSED ? (
          // Jartinet cerrada: ninguna ruta interna es accesible.
          <>
            <Route path="/login" element={<JartinetClosed />} />
            <Route path="/register" element={<JartinetClosed />} />
            <Route path="/jartinet/*" element={<JartinetClosed />} />
          </>
        ) : (
          <>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />

            <Route
              path="/jartinet"
              element={
                <ProtectedRoute>
                  <JartinetLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/jartinet/home" replace />} />
              <Route path="home" element={<JartinetHomePage />} />
              <Route path="social" element={<JartinetSocialPage />} />
              <Route path="banco" element={<JartinetBancoPage />} />
              <Route path="banco/inversiones" element={<JartinetInversionesPage />} />
              <Route path="jartibet" element={<JartiBetPage />} />
              <Route path="buzon" element={<JartinetBuzonPage />} />
              <Route path="hermandades" element={<JartinetHermandadesPage />} />
              <Route path="hall-of-fame" element={<HallOfFamePage />} />
              {/* Sin uid es el carnet propio; con uid, el de otro ciudadano. */}
              <Route path="carnet" element={<CarnetPage />} />
              <Route path="carnet/:uid" element={<CarnetPage />} />
              <Route path="bandas" element={<JartinetBandasPage />} />
              <Route path="organizaciones" element={<JartinetOrganizacionesPage />} />
              <Route path="arzobispado" element={<JartinetArzobispadoPage />} />
              <Route path="personalizables" element={<PersonalizablesPage />} />
              <Route path="personalizables/pedidos" element={<PersonalizablesPedidosPage />} />
              {/* Ruta antigua de la página de Packs: se conserva redirigiendo
                  para no romper enlaces ya repartidos. */}
              <Route path="packs-personalizados" element={<Navigate to="/jartinet/personalizables" replace />} />
              <Route path="comprobar-shaders" element={<ComprobarShadersPage />} />
              <Route path="eljartiingles" element={<ElJartiInglesPage />} />
              <Route path="eljartiingles/pedidos" element={<JartiInglesPedidosPage />} />
              {/* JartiMarchas: la propia página comprueba que diriges alguna banda. */}
              <Route path="jartimarchas" element={<JartiMarchasPage />} />
              <Route path="calendario" element={<JartinetCalendarioPage />} />
              <Route path="avisos" element={<AvisosPage />} />
              <Route path="periodico" element={<JartinetPeriodicoPage />} />
              <Route path="redaccion" element={<PeriodicoRedaccionPage />} />
              <Route path="mod-cofrade" element={<JartinetModCofradePage />} />
              <Route path="jarticards" element={<JarticardsPage />} />
              <Route path="programa-semana-santa" element={<JartinetProgramaSemanaSantaPage />} />
              <Route path="admin/home" element={<AdminHomePage />} />
              <Route path="admin/calendario" element={<AdminCalendarioPage />} />
              <Route path="admin/contratos" element={<AdminContratosPage />} />
              <Route path="admin/avisos" element={<AdminAvisosPage />} />
              <Route path="admin/noticias" element={<AdminNoticiasPage />} />
              <Route path="admin/mod" element={<AdminModPage />} />
              <Route path="admin/periodico" element={<AdminPeriodicoPage />} />
              <Route path="admin/social" element={<AdminSocialPage />} />
              <Route path="admin/programa-ss26" element={<AdminProgramaSS26Page />} />
              <Route path="admin/banco" element={<AdminBancoPage />} />
              <Route path="admin/discord" element={<AdminDiscordPage />} />
              <Route path="admin/mapa" element={<AdminMapaPage />} />
              <Route path="admin/arzobispado" element={<AdminArzobispadoPage />} />
              <Route path="admin/hermandades" element={<AdminHermandadesPage />} />
              <Route path="admin/bandas" element={<AdminBandasPage />} />
              <Route path="admin/usuarios" element={<AdminUsuariosPage />} />
              <Route path="admin/personalizables" element={<AdminPersonalizablesPage />} />
              <Route path="admin/packs" element={<Navigate to="/jartinet/admin/personalizables" replace />} />
              <Route path="admin/organizaciones" element={<AdminOrganizacionesPage />} />
              <Route path="admin/jartibet" element={<AdminJartiBetPage />} />
              <Route path="admin/jarticards" element={<AdminJarticardsPage />} />
              <Route path="admin/seguridad-mod" element={<AdminSeguridadModPage />} />
              <Route path="admin/seguridad-roblox" element={<AdminSeguridadRobloxPage />} />
              <Route path="admin/mapa-servidor" element={<AdminMapaServidorPage />} />
              <Route path="admin/iglesias" element={<AdminIglesiasPage />} />
              <Route path="admin/tiempo" element={<AdminTiempoPage />} />
              <Route path="admin/actividad" element={<AdminActividadPage />} />
              <Route path="admin/cecop" element={<AdminCecopPage />} />
              <Route path="admin/jartiingles" element={<AdminJartiInglesPage />} />
              <Route path="admin/shaders" element={<AdminShadersPage />} />
              <Route path="admin/galeria" element={<AdminGaleriaPage />} />
              <Route path="admin/estampitas" element={<AdminEstampitasPage />} />
              <Route path="admin/jartimarchas" element={<AdminJartiMarchasPage />} />
            </Route>
          </>
        )}

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ErrorBoundary>
  );
}
